<template>
    <label
        v-if="$slots.default"
        class="block text-xs font-semibold text-neutral-600"
    >
        <slot />
    </label>
</template>
